import { KYMW1100Model } from '../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * タグ情報を取得するクラス
 *
 * @export GetTagListService
 * @class GetTagListService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetTagListService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private tagIdList: Array<any>;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTagListService
   */
  private getBody(): PlessRequest {
    // タグ情報
    let searchObj = {};
    if (this.tagIdList.length > 0) {
      searchObj = {
        tagIdList: {
          combination: this.tagIdList.map(_ => ({
            parameter: {
              tagId: _.tagId,
            }
          }))
        }
      };
    }
    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTagListService
   */
  execute(model: KYMW1100Model, tagIdList: Array<any>, successFunc: Function = null): void {
    this.model = model;
    this.tagIdList = tagIdList;
    this.successFunc = successFunc;
    this.send('getTagInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTagListService
   */
  success(data: any): void {
    this.model.setTagInfo(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
